module.exports = __webpack_public_path__ + "static/media/exchange-alt.af2466a1.svg";